import styled from '@emotion/styled';
import { Button } from '@progress/kendo-react-buttons';
import { CalendarCell, CalendarCellProps } from '@progress/kendo-react-dateinputs';

interface ITimeSlotContainerProps {
  transform?: string;
}

export const Container = styled.div<ITimeSlotContainerProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({ transform }) => (transform ? `transform: ${transform};` : ``)}
`;

export const ChatCalendarCell = styled(CalendarCell)<CalendarCellProps>`
  span {
    ${({ isDisabled }) => (!isDisabled ? `border: 1px solid gray;` : ``)}
  }
`;

export const TimeSlotConfirmButton = styled(Button)`
  margin-left: 1rem;
`;
